var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { class: _vm.type }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "router-link",
          { staticClass: "logo", attrs: { to: "/", tag: "div" } },
          [
            _c("span", { staticClass: "shape" }),
            _vm._v(" "),
            _c("span", { staticClass: "text" }),
          ]
        ),
        _vm._v(" "),
        _vm.type === "dft"
          ? _c(
              "a",
              {
                staticClass: "btn main txt-blk",
                attrs: { href: "" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.scrollParent.apply(null, arguments)
                  },
                },
              },
              [
                _c("span", { staticClass: "hvr" }),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [_vm._v("Try for free")]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "dash" ? _vm._t("default") : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }